<div class="vc-entry">
  @if (loading) {
    <div class="vc-entry__state">
      <h2>{{ "COMMON.LOADING" | translate }}</h2>
      <p>{{ "LOGIN.REQUIRED" | translate }}</p>
    </div>
  }

  @if (!loading && error) {
    <div class="vc-entry__state vc-entry__state--error">
      <h2>{{ "COMMON.ERROR" | translate }}</h2>
      <button type="button" class="vc-entry__retry" (click)="retry()">
        {{ "COMMON.RETRY" | translate }}
      </button>
    </div>
  }

  @if (!loading && !error && modeSelectionRequired) {
    <div class="vc-entry__mode-selector">
      <h2>{{ "ENTRY.MODE.TITLE" | translate }}</h2>
      <p>{{ "ENTRY.MODE.DESCRIPTION" | translate }}</p>
      <div class="vc-entry__mode-actions">
        <button
          type="button"
          class="vc-entry__mode-button"
          [class.is-active]="selectedMode === 'professional'"
          [disabled]="switchingMode"
          (click)="chooseMode('professional')"
        >
          {{ "ENTRY.MODE.PROFESSIONAL" | translate }}
        </button>
        <button
          type="button"
          class="vc-entry__mode-button"
          [class.is-active]="selectedMode === 'patient'"
          [disabled]="switchingMode"
          (click)="chooseMode('patient')"
        >
          {{ "ENTRY.MODE.PATIENT" | translate }}
        </button>
      </div>
    </div>
  }
</div>
